module.exports = __webpack_public_path__ + "static/media/5DPO20.3e5fe549.jpg";